import { PaymentStatus } from '@commenda/types/src/billing/types';

// User-friendly messages for each payment status
// Map of user-friendly messages for each payment status
// User-friendly messages for each payment status
export const PAYMENT_STATUS_CONFIG: Record<
  PaymentStatus,
  { title: string; message: string }
> = {
  [PaymentStatus.LOADING]: {
    title: 'Processing Your Request',
    message: 'Please wait while we process your request...',
  },
  [PaymentStatus.PAYMENT_SUCCESS]: {
    title: 'We have received your payment.',
    message: 'Please wait while we set up your service.',
  },
  [PaymentStatus.PAYMENT_FAILED]: {
    title: 'Oops! Something went wrong.',
    message: 'We couldn’t process your payment. Please try again.',
  },
  [PaymentStatus.FULFILLMENT_FAILED]: {
    title: 'Oops! Something went wrong.',
    message:
      'Your payment was successful, but we encountered an issue while setting up your service. Our team has been notified.',
  },
  [PaymentStatus.FULFILLMENT_PROCESSED]: {
    title: 'You are all set!',
    message: 'Your order has been successfully processed.',
  },
  [PaymentStatus.CONNECTION_TIMEOUT]: {
    title: 'Oops! Something went wrong.',
    message: 'We couldn’t process your payment. Please try again.',
  },
  [PaymentStatus.MAX_RETRIES_REACHED]: {
    title: 'Oops! Something went wrong.',
    message: 'We couldn’t process your payment. Please try again.',
  },
};
